import FieldText from "../Components/Fields/FieldText";
import FieldSelect from "./Fields/FieldSelect";

import FieldUpload, {
  thumbsContainer,
  thumb,
  thumbInner,
} from "../Components/Fields/FieldUpload";
import Image from "../Components/Image/image";
import GoogleAutoComplete from "../Components/GoogleAutoComplete";
import { Row } from "react-bootstrap";
import React, { useState } from "react";
import "../Assets/Css/index.scss";

const ChurchInfoBranding = (props) => {
  const {
    churchName,
    setChurchName,
    churchAddress,
    setChurchAddress,
    fullLogo,
    setFullLogo,
    logoSymbol,
    setLogoSymbol,
    fullLogoError,
    logoSymbolError,
    timezone,
    setTimezone,
    timezones,

    setCity,
    setState,
    setZipCode,
    setLatitude,
    setLongitude,
  } = props;

  const customAddFiles = (prop) => (
    <aside style={thumbsContainer}>
      <div style={thumb} className="gallery-thumbnail">
        <div style={thumbInner} {...prop}>
          <div className="upload-btn">Upload your image</div>
        </div>
      </div>
    </aside>
  );

  return (
    <div>
      <h2 className="section-title">Branding</h2>
      <Row>
        <FieldText
          label="Church Name"
          type="text"
          onChange={(x) => setChurchName(x.target.value)}
          placeholder="Church Name"
          value={churchName}
          className="col-md-12"
          required={true}
        />
      </Row>
      <Row>
        <GoogleAutoComplete
          label="Church Address"
          address={churchAddress}
          setAddress={setChurchAddress}
          setCity={setCity}
          setState={setState}
          setZipCode={setZipCode}
          setLatitude={setLatitude}
          setLongitude={setLongitude}
          required={true}
          className="col-md-12"
        />
      </Row>
      <Row>
        <FieldSelect
          label={`Timezone`}
          options={timezones}
          className={`col-md-12`}
          onChange={setTimezone}
          value={timezone}
          placeholder={`Choose the Timezone`}
          required={true}
        />
      </Row>

      <div className="col-md-12">
        {" "}
        <FieldUpload
          label="Church Full Logo"
          files={fullLogo}
          thumbNailClassName={`product-thumbnail-info`}
          customAddFile={customAddFiles}
          onChange={(a) => {
            setFullLogo(a);
          }}
          error={fullLogoError}
        />
      </div>
      <div className="col-md-12">
        {" "}
        <FieldUpload
          label="Church Logo Symbol"
          files={logoSymbol}
          thumbNailClassName={`product-thumbnail-info`}
          customAddFile={customAddFiles}
          onChange={(a) => {
            setLogoSymbol(a);
          }}
          error={logoSymbolError}
        />
      </div>
    </div>
  );
};
export default ChurchInfoBranding;
